import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import CheckboxEmptyIcon from 'assets/img/icons/CheckboxEmptyIcon';
import CheckboxFilledIcon from 'assets/img/icons/CheckboxFilledIcon';
import useFilterActions from 'pages/PlaygroundV2Page/Filter/useFilterActions';
import { ChangeEvent, useState } from 'react';
import { BRIGHT_BLUE } from 'utils/theme';

const ClearAllCheckbox = ({ selectedSearchEngines }: { selectedSearchEngines: string[] }) => {
  const { resetFilters } = useFilterActions();
  const [checkedClearAll, setCheckedClearAll] = useState<boolean>(false);

  const handleChangeClearAll = (event: ChangeEvent<HTMLInputElement>) => {
    setCheckedClearAll(event.target.checked);
    resetFilters();
  };

  return (
    <FormControlLabel
      sx={{ pt: 2 }}
      control={
        <Checkbox
          checked={selectedSearchEngines?.length ? false : checkedClearAll}
          onChange={handleChangeClearAll}
          sx={{
            px: 1,
          }}
          icon={<CheckboxEmptyIcon />}
          checkedIcon={<CheckboxFilledIcon />}
        />
      }
      label={<Typography color={BRIGHT_BLUE}>Clear all</Typography>}
    />
  );
};

export default ClearAllCheckbox;
